import dayjs from 'dayjs';

const DE = {
  header: {
    Home: 'Home',
    News: 'Journalismus',
    Manufacture: 'Herstellen von Schimmel',
    Product: 'Produktanzeige',
    Mall: 'Molds Mall',
    Platform: 'Bestellplattform',
    Contact: 'Geschäftskontakt',
    Wechat: 'Wechat',
    TechnicalStrength: 'Fertigkeiten',
    CustomerCase: 'Kundenbeispiele',
    moldCloud: 'Mold Cloud'
  },
  section: {
    introduce: {
      // companyName:'Zhejiang die fine machine Co., LTD',
      companyName:'Ningbo Daxie Development ZONE Tianzheng MOULD Co., Ltd.',
      title: 'Firmenprofil',
      more:'Mehr Wissen',
      content: 'Ningbo Tianzheng mould Co., Ltd., gelegen in Daxie National Economic Development Zone, Ningbo City, Zhejiang Province, China, wurde in 2000 gegründet. Seit seiner Gründung hat sich das Unternehmen auf Technologie und Qualität spezialisiert und hat sich im Laufe der Jahre immer auf die Konstruktion und Herstellung von Druckgussformen konzentriert. Die Formen, die von der Firma entworfen, entwickelt und produziert werden, sind hauptsächlich für große namhafte Hersteller im In- und Ausland, einschließlich vieler Bereiche wie Autoteile, medizinische Geräte, Beleuchtungssysteme und Kommunikationsprodukte. Die Produkte werden in das ganze Land, Japan, Nordamerika und Europa exportiert.',
    },
    products:{
      title:'Produkt',
      subtitle:'COMPANY PRODUCTS',
      more: 'Details anzeigen'
    },
    // honor: 'Ehre des Unternehmens',
    // honor: 'Ehre des Unternehmens',
    honor: {
      title:'Ehre des Unternehmens',
      more: 'Mehr Wissen',
      articleTitle:'National-level specialized and innovative "little giant" enterprise.',
      content:'With a focus on quality, Ningbo Tianzheng Mould Co., Ltd. has defined itself as a benchmark of lean manufacturing through continuous innovation and steadfastness. Through constant development and transformation, it has forged a strong backbone for national brands. | As a national-level specialized and innovative "little giant" enterprise, Tianzheng Mould is a leading company in the field of large magnesium alloy structural parts die casting molds in China. It possesses core technologies in the design, manufacturing, and production processes of large magnesium alloy molds, as well as management and service capabilities throughout the entire lifecycle of molds.'
    },
    tags:{
      win:'Zusammenarbeit zum beiderseitigen Nutzen',
      benefitingAll:'Nutzen für alle',
      honesty:'Ehrlichkeit und Zuverlässigkeit',
      brandValue:'Markenwert'
    },
    qrTips:'Scannen Sie QR-Code auf WeChat, um dem offiziellen Konto zu folgen',
    partner: {
      title: 'Wichtige Kunden',
      firstRow: 'Toyota | GE | Hella',
      secondRow: 'Zhongtai | Honda | Ford',
      thirdRow: 'Peugeot | Aisin | Mercury',
      fourRow: 'Porsche | Mercury | Aisin',
      fifthRow: 'SAIC | Nidec',
    },
    culture: 'Unternehmenskultur',
    newsBlock: {
      more: 'Mehr Wissen',
      title: 'Journalismus'
    },
    poster: {
      title: 'CHINA'
    },
    CustomerCase: {
      title: 'Der fall des kunden',
      more: 'Mehr Wissen'
    }
  },
  footer: {
    blockTitles:{
      about:'Über Tianzheng',
      moldManufacturing:'Formenbau',
      friendlyLinks:'Freundliche Links',
      contactInformation:'Kontaktinformationen'
    },
    technology:'Technische Forschung und Entwicklung',
    quality:'Qualitätssicherung',
    deviceSupport:'Geräteunterstützung',
    home: ' Home',
    contact: ' Sprechen Sie uns an',
    molds: ' Molds Mall ',
    order: ' Bestellplattform',
    mail: ' Briefkasten',
    business: ' Geschäft',
    license: ' License',
    wx: 'Offizieller Wechat',
    phone: 'Telefon: ',
    fax: 'Fax: ',
    mailbox: 'Mailbox: tony@tzmc.com',
    website: 'Website: http://www.tzmc.com',
    record: 'Nr.: ',
    copyright: `©${dayjs().year()} Copyright Tianzheng mould Co.,Ltd.`,
    news: 'Journalismus',
    product: 'Produktanzeige',
    customerCase: 'CDer fall des kunden',
    power: 'Fertigkeiten',
    moldCloud: 'Mold Cloud'
  },
  manufacture: {
    title: 'Herstellen von Schimmel',
    subtitle: 'Technologie | Qualität | Ausrüstung | System',
    crumbs: 'Ihr aktueller Standort->',
    technology: 'Das Unternehmen hat Spitzenkräfte in Druckguss-Technologie und Formenbau aus dem In- und Ausland versammelt. Das Team ist solide, stabil, vereint und arbeitet effizient zusammen. Das Unternehmen hat mehrere Design- und Entwicklungszentren eingerichtet, um einen wissenschaftlich fundierten und effektiven Herstellungsprozess von der Entwicklung und dem Design der Formen bis hin zur Produktion und Auslieferung zu gewährleisten. Derzeit beschäftigt das Unternehmen über 30 Entwicklungs- und Technikmitarbeiter, darunter auch Ingenieure aus dem Ausland. Diese solide und stabile Talentschicht bietet eine zuverlässige Grundlage für das Design der Formen sowie deren Nutzung und Wartung durch die Kunden.',
    quality: 'Ziel des Überlebens auf der Basis der Qualität, verfolgen Sie die Entwicklung auf der Basis der Effizienz.Hochpräzise Laser-Scannen Tri-Koordinatenmessgerät sorgen für eine gründliche Erkennung, um sicherzustellen, dass alle Gussformen, die Tianzheng produziert, von Seiko Qualität sind.',
    equipment: 'Mit jahrelanger Erfahrung im Formenbau hat das Unternehmen einen Arbeitsprozess abgeschlossen, der dem charakteristischen Fertigungs- und Managementbedarf des TZMC entspricht.so dass jeder Satz von Formen haben optimale Fertigungslinien eine Betriebsanleitung. Tianzheng Formen wurden mit einer Reihe von Weltklasse-Präzisions-Formenbau ausgestattet.',
    system: 'Tianzheng mould führt E-man Produktionsmanagementsystem und APS Produktionsplanungssystem ein, um Informatisierung, Verfeinerung und Fluss des Produktionsmanagements zu realisieren, den Produktionszyklus von Schimmel zu verkürzen und die Kostenmanagementfähigkeit zu verbessern.',
    team: {
      title: 'Qualitätssicherung und Forschungs- und Entwicklungs-Team',
      content: 'Das Unternehmen hat Spitzenkräfte in Druckguss-Technologie und Formenbau aus dem In- und Ausland versammelt. Das Team ist solide, stabil, vereint und arbeitet effizient zusammen. Das Unternehmen hat mehrere Design- und Entwicklungszentren eingerichtet, um einen wissenschaftlich fundierten und effektiven Herstellungsprozess von der Entwicklung und dem Design der Formen bis hin zur Produktion und Auslieferung zu gewährleisten. Derzeit beschäftigt das Unternehmen über 40 Entwicklungs- und Technikmitarbeiter, darunter auch Ingenieure aus dem Ausland. Diese solide und stabile Talentschicht bietet eine zuverlässige Grundlage für das Design der Formen sowie deren Nutzung und Wartung durch die Kunden.',
      technicalPersonnel: 'Techniker',
      undergraduateDegree: 'Bachelor-Abschluss',
      developmentCenter: 'Design- und Forschungszentrum',
      GenuineDesignSoftware: 'Lizenzierte Designsoftware'
    },
    patent: {
      companyName: 'T·Z·M·C',
      slogan: 'Baute eigenschaften, führte durch patente und gab zeugnis',
      subSlogan: 'Quality Lays the Foundation, Patents Lead the Way, Honors Bear Witness'
    },
    equipments: {
      title: 'Hochpräzise Ausrüstung für hochwertige Produkte',
      content: 'Tianzheng Formen legt den Fokus auf Qualität und Effizienz und verfügt über weltklasse Präzisionsformenverarbeitungsausrüstung sowie importierte Hochgeschwindigkeitsbearbeitungszentren mit Mikrometergenauigkeit. Dies ermöglicht es uns, die hohen Präzisionsanforderungen unserer Kunden an Formen zu erfüllen. Zudem hat das Unternehmen hochpräzise Laserscanning-Dreikoordinatenmessgeräte eingeführt, um umfassende Prüfungen durchzuführen und sicherzustellen, dass jede Form die höchsten Präzisionsstandards erfüllt. Durch jahrelange Produktionserfahrung hat sich ein Arbeitsablauf entwickelt, der den spezifischen Anforderungen des Unternehmens entspricht und optimale Prozessrouten sowie Arbeitsanweisungen für die Formenherstellung bietet.',
      MeasuringInstrument: 'Hochpräzises Laserscanning-DKM',
      MachiningCenter: 'Mikro-HSC-Zentrum'
    },
    systems: {
      title: 'Tianzheng Formen hat das E-MAN Produktionssystems und das APS Planungs- und Terminierungssystem eingeführt.',
      ProductionManagement: {
        title: 'Produktionsmanagement',
        desc: 'Informationsintegration und visuelle Darstellung, um die Informations-, Fein- und Prozessgestaltung des Produktionsmanagements zu realisieren.'
      },

      ProductionCycle: {
        title: 'Produktionszyklus',
        desc: 'Optimierung der Produktionsplanung, Echtzeitüberwachung des Produktionsfortschritts, Verkürzung des Formenproduktionszyklus.'
      },

      ManagementCosts: {
        title: 'Verwaltungskosten',
        desc: 'Durch die Optimierung der Produktionsabläufe werden Verluste reduziert und durch eine vernünftige Anordnung von Produktions Chargen werden feste Kosten gesenkt.'
      }
    }
  },
  contact: {
    title: 'Kontaktieren Sie uns',
    business: {
      title: 'Geschäftskontakt',
      domestic: 'inländische',
      international: 'international'
    },
    technology: {
      title: 'Technische Verbindung',
      Daxie: 'Daxie Technology Department',
      Beilun: 'Technische Abteilung Beilun'
    },
    location: 'No. 5, Beidu Road, Daxie Development Zone, Ningbo, Zhejiang',
    tab: {
      business: 'Kooperation seitens der händler',
      job: 'Personal einstellen'
    },
    job: {
      title: 'stellenbelegung',
      SocialRecruitment: 'stellenangebote',
      CampusRecruitment: 'Auf dem campus rekrutiert',
      search: 'Suche nach arbeit',
      Duty: 'Unser job',
      JobRequirements: 'Schnappt ihn euch',
      TreatmentAndWelfare: 'Das ist der regelsatz',
      numberRecruitsUnit: 'Personen',
      resume: 'Lieferung für den lebenslauf',
      uploadResume: 'Lebenslauf hochladen',
      cancel: 'korrekt',
      confirm: 'Lade hoch',
      uploadFail: 'Upload fehlgeschlagen',
      uploadSuccess: 'Upload erfolgreich.',
      emptyDesc: 'Keine daten'
    },
    contact: {
      phone: 'Telefon',
      fax: 'Fax',
      email: 'Mailbox',
      address: 'Adresse'
    }
  },
  content:{
    News: 'Journalismus',
    Company: 'Firma',
    Industry: 'Industrie',
    More: 'Mehr',
    NewsCenter: 'News Center',
    Location: 'Ihr aktueller Standort',
    All: 'Alle',
    Productdisplay: 'Anzeige des Produkts',
    Molds: 'Molde',
    Products: 'Produkt',
    Mold: 'Schimmel',
    Schimmel: 'Mold',
    Parts: 'Autoteile',
    Machinery: 'Allgemeine Maschinen',
    Other: 'Andere',
    TechnicalStrength: 'Fertigkeiten'
  },
  news: {
    createTime: 'Geteilt durch: '
  },
  companyDesc: {
    FoundingDate: 'Gründungsdatum',
    Employees: 'Mitarbeiter',
    Customer: 'Anzahl der Kunden',
    FoundingDateUnit: 'n. Chr'
  },
  notFound: {
    message: 'Die seiten, auf die sie zugehen, gibt es nicht!!!',
    tips: 'Überprüfen sie die korrekte web-adresse Oder klicken sie auf den knopf unten, um zur seite zurückzukehren',
    backHome: 'Zur seite zurückkehren'
  },
  customerService: 'Kundendienst'
}

export default DE